package com.devi3east.bashbuddy.auth.ui

sealed class AuthUiEvent {
    data class ShowMessage(val message: String) : AuthUiEvent()

    data object SignedOut : AuthUiEvent()

    object NavigateToSignUp : AuthUiEvent()
    object NavigateToSignIn : AuthUiEvent()
    object NavigateToEventsScreen : AuthUiEvent()
    data class OpenExternalSignUp(val url: String) : AuthUiEvent()
    data class OpenExternalSignIn(val url: String) : AuthUiEvent()
}